import $ from 'jquery';
import Swiper from 'swiper';
import ww from './globals';
import { switchTabs } from './utils/tabs';

$(document).ready(function() {
  // left sidebar (have articles or not)
  $('.aside-left__day').each(function(index, el) {
    if ($(el).find('.aside-left__content-article').length > 0) {
      $(el).css('display', 'block');
    } else {
      $(el).css('display', 'none');
    }
  });

  // Mobile version, icon-menu

  $('.hamburger').on('click', e => {
    e.stopPropagation();
    if ($('.overflow-mobile').hasClass('overflow-active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  $('.secondary-nav').on('click', e => {
    e.stopPropagation();
  });

  $(document).on('click', () => {
    if ($('.overflow-mobile').hasClass('overflow-active')) {
      closeMenu();
    }

    if ($('.search-block').hasClass('open')) {
      $('.search-block')
        .removeClass('open')
        .hide();
    }
  });

  function closeMenu() {
    $('body').removeClass('menu-open');
    $('.overflow-mobile').removeClass('overflow-active');
    $('.hamburger').removeClass('is-active');
    $('.secondary-nav__logo').removeClass('active-second-logo');
    $('.secondary-nav')
      .fadeToggle()
      .removeClass('hide-mob-menu');
  }

  function openMenu() {
    $('body').addClass('menu-open');
    $('.hamburger').addClass('is-active');
    $('.secondary-nav__logo').addClass('active-second-logo');
    $('.overflow-mobile').addClass('overflow-active');
    $('.secondary-nav')
      .fadeToggle()
      .addClass('hide-mob-menu');
  }

  //mobile version, show menu

  $('.topic-all__mobile-vers').on('click', function() {
    $(this)
      .find('.topic-all__meta')
      .toggleClass('topic-all__mobile-show');
    $(this)
      .find('.icon-topic-all__vector-down')
      .toggleClass('vector-up');
  });

  //sorted radnuk news aside-left
  $('.filter__click').on('click', function() {
    let filterCont = $(this).attr('data-tab');

    $('.filter__click').removeClass('current');
    $('.filter__content').addClass('current');

    $(this).addClass('current');

    if (!filterCont) return;
    $(`.filter__content:not([data-tab="${filterCont}"])`)
      .removeClass('current')
      .closest('.aside-left__day')
      .find('.aside-left__caption-date')
      .addClass('current');
  });

  // tabs with news aside-left
  $('.aside-left .r-tabs__anchor').on('click', e => {
    switchTabs($(e.currentTarget));
  });

  // Left sidemenu height
  const dashboard = $('.dashboard');

  if (dashboard.length && ww > 1199) {
    let dashboardHeight = dashboard.innerHeight();

    dashboard
      .parents('.dashboard__wrapper')
      .find('.aside-left')
      .css('max-height', dashboardHeight);
  }

  //raiting system

  $('.btnRaiting').on('click', function() {
    $(this)
      .find('.icon-raiting')
      .toggleClass('raiting-actv');
  });

  //tab sorted on popular section

  $('.tab-link').on('click', function() {
    var tabId = $(this).attr('data-tab');

    $('.tab-link').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');

    $(`.tab-content[data-tab="${tabId}"]`).addClass('current');
  });

  if ($('.offer__catalog').length && ww < 1200) {
    new Swiper('.offer__catalog', {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      spaceBetween: 10,
      breakpoints: {
        // when window width is >= 767px
        767: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        }
      }
    });
  }

  // global web search
  $('.open-search').on('click', function(e) {
    e.stopPropagation();
    $('.search-block')
      .stop(true, true)
      .addClass('open')
      .toggle()
      .find('.mailing__form-input')
      .focus();
  });

  $('.search-block').on('click', e => {
    e.stopPropagation();
  });

  // Main menu toggling on mobile
  if (ww < 1200) {
    $('.secondary-nav__link-event').on('click', function() {
      $('.secondary-nav__link-event')
        .not($(this))
        .removeClass('active');
      $('.secondary-nav__link-event')
        .not($(this))
        .find('.icon-secondary-nav__vector-down')
        .removeClass('vector-active');
      $(this).toggleClass('active');
      $('.secondary-nav__sub-menu')
        .not($(this).siblings('.secondary-nav__sub-menu'))
        .stop(true, true)
        .slideUp();
      $(this)
        .siblings('.secondary-nav__sub-menu')
        .stop(true, true)
        .slideToggle('slow');
      $(this)
        .find('.icon-secondary-nav__vector-down')
        .toggleClass('vector-active');
    });
  }

  // close update info sub

  $('.close-update').on('click', e => {
    let $this = $(e.currentTarget);

    document.cookie = 'cookieUpdateInfo=true';

    $this.closest('.update-subs').fadeOut();
  });

  (function checkUpdateDubs() {
    let checkCookie = document.cookie.replace(
      /(?:(?:^|.*;\s*)cookieUpdateInfo\s*\=\s*([^;]*).*$)|^.*$/,
      '$1'
    );
    if (!checkCookie) {
      $('.update-subs').fadeIn();
    } else {
      $('.update-subs').fadeOut();
    }
  })();
});
